/**
 * Wylicza registrable domain z URL-a panelu, aby cookie mogło być współdzielone
 * między subdomenami (np. financing-widget.przelewy24.pl ↔ financing.przelewy24.pl).
 *
 * Zwraca undefined dla localhost / adresów IP — tam cookie host-only i tak jest
 * współdzielone między portami tego samego hosta (porty nie izolują cookies).
 */
export function getSharedCookieDomain(panelUrl) {
    if (!panelUrl) {
        return undefined;
    }
    var hostname;
    try {
        hostname = new URL(panelUrl).hostname;
    }
    catch (_a) {
        return undefined;
    }
    var isIpAddress = /^[\d.]+$/.test(hostname);
    if (hostname === 'localhost' || isIpAddress) {
        return undefined;
    }
    var labels = hostname.split('.');
    if (labels.length < 2) {
        return undefined;
    }
    // np. panel.przelewy24.pl -> przelewy24.pl (współdzielone z financing*.przelewy24.pl)
    return labels.slice(-2).join('.');
}
